import api from '@app/utils/api';
import qs from 'qs';

export const fetchOwnerCorporateList = (params) => {
  return api.get(`/owner/corporate/list?${qs.stringify(params)}`);
};
